import React from "react";
import {
    Form,
    Radio,
    Input,
    Select,
    Tag
} from "antd";
import NumberSelectOptionMake from "./NumberSelectOptionMake";

const Item = Form.Item;

function getSetItems(extendData= {}){

    return <>
        <Item
            label={"选择框大小"}
            name={["selectOption","size"]}
        >
           <Radio.Group>
               <Radio value={"small"}>小</Radio>
               <Radio value={"middle"}>中</Radio>
               <Radio value={"large"}>大</Radio>
           </Radio.Group>
        </Item>
        <Item
            label={"提示语"}
            name={["selectOption","placeholder"]}
        >
            <Input
                maxLength={20}
            />
        </Item>
        <Item
            label={"标签"}
            name={["label"]}
        >
            <Input
                maxLength={20}
            />
        </Item>
        <Item
            label={"映射选项"}
            name={["listSpecial"]}
        >
            <NumberSelectOptionMake/>
        </Item>
    </>
}

function getDefaultValues(){
    return {
        label: null,
        selectOption: {
            size: "middle",
            placeholder: "请选择内容",
        },
        listSpecial: [],
    }
}

export default {
    getSetItems,
    getDefaultValues,
}